import PPAdressAutocomplete from "./PPAdressAutocomplete";
import PPaddMessageManagementForGF from "./PPaddMessageManagementForGF";

document.addEventListener('DOMContentLoaded', ()=> {

    document.querySelector('#input_20_18').setAttribute('readonly', 'readonly');

    const ppAddressAutocomplete = new PPAdressAutocomplete(
        'input_20_17',
        'input_20_18',
        'input_18',
        'validation_message_20_18'
    );
    ppAddressAutocomplete.main();

    //============================================================================
    const ppMessageManagement =  new PPaddMessageManagementForGF('#gform_20');
    ppMessageManagement.addElementsByID('4');
    ppMessageManagement.addElementsByID('7');
    ppMessageManagement.addElementsByID('8');
    ppMessageManagement.addElementsByID('9');
    ppMessageManagement.addElementsByID('12');
    ppMessageManagement.addElementsByID('13');
    ppMessageManagement.setElements();
});

